require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-60-best-fashion-ecommerce-sites.json") })
        }
      }, "path---blog-60-best-fashion-ecommerce-sites");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-60-best-fashion-ecommerce-sites!./.cache/json/blog-60-best-fashion-ecommerce-sites.json
// module id = 414
// module chunks = 231608221292675